var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import IconContainer, { IconSVG } from "./IconContainer";
var IconCopyVideo = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", null,
                React.createElement("g", { transform: "translate(7.26 7.406)" },
                    React.createElement("path", { d: "M20.5,6.3l-6.2,4.4l6.2,4.4V6.3z" }),
                    React.createElement("path", { d: "M2.9,4.6h9.7c1,0,1.8,0.8,1.8,1.8v8.8c0,1-0.8,1.8-1.8,1.8H2.9c-1,0-1.8-0.8-1.8-1.8V6.3\n                        C1.1,5.4,1.9,4.6,2.9,4.6C2.9,4.6,2.9,4.6,2.9,4.6z" })),
                React.createElement("path", { d: "M4.9,18H4c-1,0-1.8-0.8-1.8-1.8l0,0V7.4c0-1,0.8-1.8,1.8-1.8h9.7c1,0,1.8,0.8,1.8,1.8\n                    c0,0,0,0,0,0v0.9" }),
                React.createElement("path", { d: "M21.6,8.3V7.4l-1.2,0.9" })))));
});
export default IconCopyVideo;
//# sourceMappingURL=IconCopyVideo.js.map